import { useEffect } from "react";
import { Seo } from "./Seo";

export default function NotFound() {
  useEffect(() => {
    const m = document.createElement("meta");
    m.name = "robots";
    m.content = "noindex";
    m.id = "nf-robots";
    document.head.appendChild(m);
    return () => m.remove();
  }, []);
  return (
    <main id="main" data-testid="not-found-page" className="bg-navy pb-28 pt-44 text-white">
      <Seo title="Seite nicht gefunden | Schwimmschule Manta" description="Diese Seite existiert nicht. Zur Startseite der Schwimmschule Manta mit Schwimmkursen im Sportbad Dieburg." path="/" />
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
        <h1 className="text-4xl font-extrabold sm:text-5xl">Seite nicht gefunden.</h1>
        <p className="mt-6 max-w-lg text-base text-slate-200">Die gesuchte Seite gibt es nicht (mehr).</p>
        <div className="mt-10 flex flex-wrap gap-4">
          <a href="/" className="rounded-full bg-white px-7 py-4 text-sm font-bold text-navy">Zur Startseite</a>
          <a href="/schwimmkurse-dieburg" className="rounded-full border border-white/40 px-7 py-4 text-sm font-bold text-white">Schwimmkurse in Dieburg</a>
        </div>
      </div>
    </main>
  );
}
